import React, {FC} from "react";
import {FeWorker} from "../../redux/types";
import {makeStyles} from "@material-ui/core";
import {LabeledTextDisplay} from "../../../../sharedComponents/LabeledTextDisplay";
import {useUpdateWorker} from "../../redux/workers.hook";
import {EditableName} from "../../../../sharedComponents/EditableName";
import {EditableTextField} from "../../../../sharedComponents/EditableTextfield";
import {EditableAddress} from "../../../../sharedComponents/EditableAddress";

const useStyles = makeStyles((theme) => ({
    spacing: {
        marginBottom: theme.spacing(2)
    }
}))

interface EditableWorkerProfileProps {
    worker?: FeWorker;
    hideHourlyWage?: boolean;
}

export const EditableWorkerProfile: FC<EditableWorkerProfileProps> = ({worker, hideHourlyWage}) => {
    const classes = useStyles();
    const {updateWorker} = useUpdateWorker()

    return (
        <div>
            <EditableName
                value={worker}
                onSubmit={updateWorker}
                className={classes.spacing}
            />
            <LabeledTextDisplay
                label="Email"
                required={true}
                type="email"
                value={worker?.email}
                className={classes.spacing}
            />
            <EditableTextField
                formProps={{
                    className: classes.spacing,
                    label: 'Telefon',
                    type: 'phone',
                    required: true,
                    initialValue: worker?.phone,
                    onSubmit: (value) => updateWorker(worker?.id || '', {phone: value as string})
                }}
                editIdentifier="phone"
            />
            <EditableAddress
                label="Adresse"
                onSubmit={(address) => updateWorker(worker?.id ?? '', {address})}
                className={classes.spacing}
                editIdentifier="address"
                value={worker?.address}
            />
            {!hideHourlyWage &&
                <EditableTextField
                formProps={{
                    className: classes.spacing,
                    label: 'Stundenlohn',
                    required: true,
                    type: 'number',
                    initialValue: worker?.hourlyWage,
                    onSubmit: (value) => updateWorker(worker?.id || '', {hourlyWage: typeof value === "string" ? parseFloat(value) : value})
                }}
                editIdentifier="hourlyWage"
                suffix={' €/h'}
                currency
            />}
            <EditableTextField
                formProps={{
                    label: 'max Arbeitsweg',
                    type: 'number',
                    required: true,
                    initialValue: worker?.maxKmToOrder,
                    onSubmit: (value) => updateWorker(worker?.id || '', {maxKmToOrder: typeof value === "string" ? parseFloat(value) : value})
                }}
                editIdentifier="maxKmToOrder"
                suffix={' Km'}
            />
        </div>
    )
}